import _ from 'lodash';
import { CargoOrder } from '../../../types/cargo';

export function getBoxAndPlaceQuantityInGroup(
  groups: Record<string, CargoOrder[]>,
) {
  return _.mapValues(groups, orders => ({
    boxQuantity: _.sumBy(orders, o =>
      _.sumBy(o.cargoPlacesJson, p => p.packageQuantity ?? 0),
    ),
    cargoPlaceQuantity: _.sumBy(orders, o =>
      _.sumBy(o.cargoPlacesJson, p => p.cargoPlaceQuantity ?? 0),
    ),
  }));
}
